/*
 * drl-price-range — ketfogantyus arcsuszka a Shopify ar-facet fole.
 *
 * Az igazsag a ket rejtett szoveges mezo (filter.v.price.gte / .lte): a csuszka
 * azokat irja, es a Dawn facets.js-e azokat kuldi fel. A csuszka sajat input
 * esemenyei meg vannak allitva (stopPropagation), kulonben minden huzas-lepes
 * ujratoltene a racsot; a keres csak elengedeskor (change) indul.
 *
 * A skala nem linearis: a poziciot negyzetre emeljuk. A katalogus 95%-a
 * 20.000 Ft alatt van, 72.000 Ft-os maximum mellett a linearis csuszka elso
 * negyedeben lenne minden termek. Igy a sav fele fedi a maximum negyedet.
 */
const DRL_PRICE_STEPS = 1000;

class DrlPriceRange extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;

    this.max = parseInt(this.dataset.max, 10) || 0;
    this.fields = Array.from(this.querySelectorAll('.drl-price__field'));
    this.thumbs = Array.from(this.querySelectorAll('.drl-price__thumb'));
    this.outs = Array.from(this.querySelectorAll('.drl-price__out'));
    this.fill = this.querySelector('[data-drl-fill]');
    if (this.max <= 0 || this.thumbs.length !== 2 || this.fields.length !== 2) return;

    this.money = this.parseFormat(this.dataset.sample || '');
    this.fromFields();

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('input', (event) => {
        event.stopPropagation();
        this.onDrag(index);
      });
      thumb.addEventListener('change', (event) => {
        event.stopPropagation();
        this.commit();
      });
    });
    this.fields.forEach((field) => field.addEventListener('change', () => this.fromFields()));
  }

  /* A bolt penzformatuma egy szerveren rendereltt mintabol: elotag, ezres jel, utotag. */
  parseFormat(sample) {
    const match = sample.match(/^(\D*)(\d[\d\D]*\d)(\D*)$/);
    if (!match) return { prefix: '', sep: ' ', suffix: '' };
    const sep = (match[2].match(/\D/) || [' '])[0];
    return { prefix: match[1], sep: sep, suffix: match[3] };
  }

  format(value) {
    const grouped = String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, this.money.sep);
    return this.money.prefix + grouped + this.money.suffix;
  }

  snap(value) {
    const step = value > 10000 ? 1000 : 500;
    return Math.min(Math.round(value / step) * step, this.max);
  }

  toPrice(position) {
    const t = position / DRL_PRICE_STEPS;
    return this.snap(this.max * t * t);
  }

  toPosition(price) {
    const clamped = Math.min(Math.max(price, 0), this.max);
    return Math.round(DRL_PRICE_STEPS * Math.sqrt(clamped / this.max));
  }

  fieldValue(index) {
    const raw = parseInt(String(this.fields[index].value).replace(/\D/g, ''), 10);
    if (Number.isNaN(raw)) return index === 0 ? 0 : this.max;
    return Math.min(Math.max(raw, 0), this.max);
  }

  fromFields() {
    this.min = this.fieldValue(0);
    this.top = this.fieldValue(1);
    if (this.min > this.top) this.min = this.top;
    this.thumbs[0].value = this.toPosition(this.min);
    this.thumbs[1].value = this.toPosition(this.top);
    this.paint();
  }

  onDrag(index) {
    const price = this.toPrice(parseInt(this.thumbs[index].value, 10));
    if (index === 0) {
      this.min = Math.min(price, this.top);
      this.thumbs[0].value = this.toPosition(this.min);
    } else {
      this.top = Math.max(price, this.min);
      this.thumbs[1].value = this.toPosition(this.top);
    }
    this.paint();
  }

  paint() {
    const left = this.toPosition(this.min) / DRL_PRICE_STEPS;
    const right = this.toPosition(this.top) / DRL_PRICE_STEPS;
    this.fill.style.left = (left * 100).toFixed(2) + '%';
    this.fill.style.right = ((1 - right) * 100).toFixed(2) + '%';
    if (this.outs[0]) this.outs[0].textContent = this.format(this.min);
    if (this.outs[1]) this.outs[1].textContent = this.format(this.top);
    this.thumbs[0].setAttribute('aria-valuetext', this.format(this.min));
    this.thumbs[1].setAttribute('aria-valuetext', this.format(this.top));
  }

  /* A vegallasokat uresen hagyjuk: igy nem kerul folosleges parameter az URL-be. */
  commit() {
    this.fields[0].value = this.min > 0 ? String(this.min) : '';
    this.fields[1].value = this.top < this.max ? String(this.top) : '';
    this.fields[0].dispatchEvent(new Event('input', { bubbles: true }));
  }
}

if (!customElements.get('drl-price-range')) {
  customElements.define('drl-price-range', DrlPriceRange);
}
